import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
  const openWhatsApp = () => {
    const phoneNumber = "+96179427021"; 
    const message =" Hello, cuties ";

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank"); 
  };

  return (
    <div style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: "1000" }}>
      <button
        onClick={openWhatsApp}
        style={{
          backgroundColor: "#25D366",
          color: "white",
          border: "none",
          borderRadius: "50%",
          padding: "15px",
          cursor: "pointer",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        <FaWhatsapp size={30} />
      </button>
    </div>
  );
};

export default WhatsAppButton;